<template>
  <div class="match-base">
    <el-card>
      <div class="match-base__title">
        匹配基础功能配置
      </div>
      <div class="match-base__search">
        <div>
          <span>用户标签:</span>
          <el-select filterable v-model="searchData.userSign" placeholder="请选择" size="small" v-el-select-loadmore="loadMore">
            <el-option label="All" value=""></el-option>
            <el-option v-for="(item, index) in signList" :key="`${item.name}-${index}`" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </div>
        <div>
          <span>用户类型:</span>
          <el-select filterable v-model="searchData.userType" placeholder="请选择" size="small">
            <el-option label="ALL" :value="null"></el-option>
            <el-option label="用户 male" :value="0"></el-option>
            <el-option label="主播 female" :value="1"></el-option>
            <el-option label="两者 both" :value="2"></el-option>

          </el-select>
        </div>
        <div>
          <span>状态:</span>
          <el-select filterable v-model="searchData.valid" placeholder="请选择" size="small">
            <el-option label="ALL" :value="null"></el-option>
            <el-option label="有效" :value="1"></el-option>
            <el-option label="无效" :value="0"></el-option>
          </el-select>
        </div>
        <el-button type="primary" size="small" @click="getMatchBase(true)">查询</el-button>
        <el-button type="success" size="small" @click="addConfig">新增</el-button>
      </div>
      <l-table :columns="columns" :data="tableList">
        <template #userType="{ row }">
          <el-tag :type="row.userType === 0 ? 'success' : ''">{{ row.userType === 0 ? '用户' : '主播' }}</el-tag>
        </template>
        <template #bothPrice="{ row }">
          <template v-if="row.userType === 0">
            <p>both: {{ row.bothPrice }} 金币</p>
            <p>男性: {{ row.manPrice }} 金币</p>
            <p>女性: {{ row.femalePrice }} 金币</p>
          </template>
          <p v-else> {{ row.hostMatchEarn }} 钻石</p>
        </template>
        <template #manMaxTimes="{ row }">
          <template v-if="row.userType === 0">
            <p>both: {{ row.bothMaxTimes }} 次</p>
            <p>男性: {{ row.manMaxTimes }} 次</p>
            <p>女性: {{ row.femaleMaxTimes }} 次</p>
          </template>
          <p v-else> {{ row.hostMatchMaxTimes }} 次</p>
        </template>
        <template #canHangUpDuration="{ row }">
          <p>挂断时间: {{ row.canHangUpDuration }} 秒</p>
          <p>通话时间: {{ row.maxChatDuration }} 秒</p>
          <p>匹配间隔时间: {{ row.matchInterval }} 秒</p>
          <p v-if="row.userType === 1"> 倒计时触发时间: {{ row.countdownTriggerTime }} 秒</p>
        </template>
        <template #usualMatchTimesConfigBO="{ row }">
          <div v-if="row.userType === 1">-</div>
          <div v-else>
            <el-card v-for="(item, ind) in row.usualMatchTimesConfigBO.configList" :key="ind" shadow="always"
              style="margin-top: 12px;">
              登录行为 {{ item.dayInterval.replace(',', '至') }} 天
              <div v-for="(innerItem, innerInd) in item.usualMatchTimesReceiveConfigList" :key="innerInd">
                <p>第 {{ innerItem.matchReceiveTimes }} 次领取匹配券数量: {{ innerItem.matchReceiveNums }} 张</p>
                <p>领取时间： {{ innerItem.matchReceiveCountdown }} 秒</p>
              </div>
            </el-card>
          </div>
        </template>
        <template #valid="{ row }">
          <el-tag :type="row.valid === 0 ? 'warning' : 'success'">{{ row.valid === 0 ? '下线' : '上线' }}</el-tag>
        </template>
        <template #operation="{ row }">
          <div class="flex-group">
            <el-button type="primary" size="small" @click="editConfig(row)">编辑</el-button>
            <el-button type="info" size="small" @click="copySubmit(row.id)">复制</el-button>
            <el-button type="danger" size="small" @click="deleteSubmit(row.id)">删除</el-button>
            <el-button :type="row.valid === 0 ? 'success' : 'warning'" size="small" @click="changeValidSubmit(row)">
              {{ row.valid === 0 ? '上线' : '下线' }}
            </el-button>
          </div>
        </template>
      </l-table>
      <el-pagination background layout="prev, pager, next" :page-count="pageCount" :current-page.sync="page"
        @current-change="getMatchBase">
      </el-pagination>
    </el-card>
    <match-base-drawer v-model="dialogData.visible" :config="dialogData.config" :isEdit="dialogData.isEdit"
      @save="saveSubmit" :sign-list="signList" @loadMore="loadMore"></match-base-drawer>
  </div>
</template>

<script>
import { matchListReq, matchListUpdateReq, matchListAddReq, matchListCopyReq, matchListDeleteReq, signListReq } from '@/api/matchConfigApi'
import LTable from '@/components/L/LTable.vue';
import MatchBaseDrawer from './MatchBaseDrawer.vue'
export default {
  components: {
    LTable,
    MatchBaseDrawer
  },
  data() {
    return {
      searchData: {
        userSign: '',
        userType: null,
        valid: null
      },
      tableList: [],
      pageCount: 1,
      page: 1,
      dialogData: {
        visible: false,
        isEdit: false,
        config: {
          userSign: '',
          userType: 0,
          bothPrice: 0,
          manPrice: 0,
          femalePrice: 0,
          hostMatchEarn: 0,
          hostMatchMaxTimes: 0,
          bothMaxTimes: 0,
          manMaxTimes: 0,
          femaleMaxTimes: 0,
          canHangUpDuration: 0,
          maxChatDuration: 0,
          matchInterval: 0,
          countdownTriggerTime: 0,
          newUserMatchTimes: 0,
          usualMatchTimesConfig: {
            configList: [{
              dayInterval: '',
              usualMatchTimesReceiveConfigList: [
                {
                  matchReceiveTimes: 0,
                  matchReceiveNums: 0,
                  matchReceiveCountdown: 0
                }
              ]
            }]
          },
          usualMatchTimesConfigBO: {
            configList: [{
              dayInterval: '',
              usualMatchTimesReceiveConfigList: [
                {
                  matchReceiveTimes: 0,
                  matchReceiveNums: 0,
                  matchReceiveCountdown: 0
                }
              ]
            }]
          },
          valid: 0,
        }
      },
      columns: [
        {
          label: '序号',
          prop: 'id'
        },
        {
          label: '规则优先级(越大越优先)',
          prop: 'priorityLevel',
          sortable: true
        },
        {
          label: '用户标签组',
          prop: 'userSign'
        },
        {
          label: '规则优先级(越大越优先)',
          prop: 'priorityLevel',
          sortable: true
        },
        {
          label: '用户类型',
          prop: 'userType'
        },
        {
          label: '匹配价格',
          prop: 'bothPrice'
        },
        {
          label: '匹配上限',
          prop: 'manMaxTimes'
        },
        {
          label: '匹配时间配置',
          prop: 'canHangUpDuration'
        },
        {
          label: '免费匹配次数配置-新手礼包',
          prop: 'newUserMatchTimes'
        },
        {
          label: '免费匹配次数配置-常规配置',
          prop: 'usualMatchTimesConfigBO',
          width: '280px'
        },
        // {
        //   label: '备注',
        //   prop: 'id'
        // },
        // {
        //   label: '优先级',
        //   prop: 'id'
        // },
        {
          label: '状态',
          prop: 'valid'
        },
        {
          label: '操作',
          prop: 'operation',
          width: '180px'
        },
      ],
      signList: [],
      page: 1,
      timer: null
    }
  },
  directives: {
    'el-select-loadmore': (el, binding) => {
      // 获取element-ui定义好的scroll盒子
      const SELECTWRAP_DOM = el.querySelector(
        '.el-select-dropdown .el-select-dropdown__wrap'
      )
      if (SELECTWRAP_DOM) {
        SELECTWRAP_DOM.addEventListener('scroll', function () {
          /**
           * scrollHeight 获取元素内容高度(只读)
           * scrollTop 获取或者设置元素的偏移值,
           *  常用于:计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
           * clientHeight 读取元素的可见高度(只读)
           * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
           * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
           */
          const condition =
            this.scrollHeight - this.scrollTop-10 <= this.clientHeight
          if (condition) binding.value()
        })
      }
    },
  },
  methods: {
    loadMore(){
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.page++
        this.getSignList(this.page)
      }, 1000)
    },
    async getSignList() {
      const res = await signListReq(this.page);
      if (res.code === 0 || res.status === 0) {
        this.$set(this, 'signList', this.signList.concat(res.data.list))
      } else {
        this.$message.warning(res.msg || res.message)
      }
    },
    // 获取匹配基础功能配置
    async getMatchBase(bool) {
      if (bool === true) this.page = 1
      const res = await matchListReq(this.searchData, this.page)
      if (res.code === 0) {
        this.tableList = res.data.resultList
        this.$message({ type: 'success', message: "查询成功" })
        this.pageCount = res.data.totalPages
      } else {
        this.$message.error(res.msg)
        this.tableList = []
      }
    },
    editConfig(row) {
      this.dialogData.isEdit = true;
      this.dialogData.config = JSON.parse(JSON.stringify(row));
      this.dialogData.visible = true;
    },
    addConfig() {
      this.dialogData.isEdit = false;
      this.dialogData.config = this.$options.data().dialogData.config;
      this.dialogData.visible = true;
    },
    deleteSubmit(id) {
      this.$confirm('是否删除该配置?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await matchListDeleteReq({ id })
        if (res.code === 0 || res.status === 0) {
          this.$message.success('delete success')
          this.getMatchBase()
        } else {
          this.$message.warning(res.msg || res.message)
        }
      }).catch(() => {
      });
    },
    copySubmit(id) {
      this.$confirm('是否复制该配置?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await matchListCopyReq({ id })
        if (res.code === 0 || res.status === 0) {
          this.$message.success('copy success')
          this.getMatchBase()
        } else {
          this.$message.warning(res.msg || res.message)
        }
      }).catch(() => {
      });
    },
    changeValidSubmit(row) {
      let text = row.valid === 0 ? '是否进行上线操作' : "是否进行下线操作"
      this.$confirm(text, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await matchListUpdateReq({
          ...row,
          valid: Math.abs(row.valid - 1),
          usualMatchTimesConfig: JSON.stringify(row.usualMatchTimesConfigBO)
        })
        if (res.code === 0 || res.status === 0) {
          this.$message.success('change success')
          this.getMatchBase()
        } else {
          this.$message.warning(res.msg || res.message)
        }
      }).catch(() => {
      });
    },
    async saveSubmit(obj) {
      // 编辑
      let res = null;
      if (this.dialogData.isEdit) {
        res = await matchListUpdateReq(obj)
      } else {
        res = await matchListAddReq(obj)
      }
      if (res.code === 0 || res.status === 0) {
        this.$message.success('操作成功')
        this.dialogData.visible = false;
        this.getMatchBase()
      } else {
        this.$message.warning(res.msg || res.message)
      }
    }
  },
  mounted() {
    this.getMatchBase()
    this.getSignList()
  },
  activated() {
    // 移除重复调用，避免第一页数据重复加载
    // this.getSignList()
  }
}
</script>

<style scoped lang="scss">
.match-base {
  &__main {
    height: 100px;
  }

  &__title {
    font-size: 22px;
    font-weight: 600;
    margin-bottom: 20px;
  }

  &__search {
    display: flex;
    gap: 14px;
    flex-wrap: wrap;

    .el-select,
    .el-input {
      margin-left: 12px;
    }
  }
}

.flex-group {
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
  min-height: 80px;

  .el-button {
    margin: 0;
  }
}
</style>